import type { SymbolIndexFileEntry } from '../build/collect-file-entries.js';

export function collectUpstreamEntries(
  entry: SymbolIndexFileEntry,
  resolveEntry: (filePath: string) => SymbolIndexFileEntry | undefined,
): SymbolIndexFileEntry[] {
  const entriesByPath = new Map<string, SymbolIndexFileEntry>();
  entriesByPath.set(entry.relPath, entry);

  const visit = (filePath: string, visited: Set<string>): void => {
    if (visited.has(filePath)) return;
    visited.add(filePath);
    const resolved = resolveEntry(filePath);
    if (resolved == null) return;
    entriesByPath.set(filePath, resolved);
    for (const binding of resolved.imports) {
      if (binding.sourceFilePath) visit(binding.sourceFilePath, visited);
    }
  };

  for (const star of entry.imports) {
    if (star.importKind !== 'star' || !star.sourceFilePath) continue;
    visit(star.sourceFilePath, new Set());
  }

  return [...entriesByPath.values()];
}
